import { hotPink, titles } from '../../../../web/styles/colors';
import { Layouts } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	body: {
		...Layouts.verticalStack(60),
	},
	draftsSectionTitle: {
		color: hotPink,
	},
	header: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		justifyContent: 'space-between',
		padding: `30px 0`,
	},
	headerAccessory: {
		alignItems: 'center',
		display: 'flex',
	},
	headerTitle: {
		color: titles,
		fontSize: 24,
	},
	sectionTitle: {
		color: titles,
		fontSize: 18,
	},
});
